import React from 'react'
import HomePageComp from '../components/HomePageComp'

const HomePage = () => {
  return <HomePageComp />
}

export default HomePage
